module.exports = __webpack_public_path__ + "media/images/icons/filled/money-collect-25f32e49e2bf31173971c85f2308c0c6.svg";